import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Calendar from './components/Calendar';
import { getAuth } from 'firebase/auth';
import { doc, collection, onSnapshot, updateDoc, deleteDoc } from 'firebase/firestore';
import { db } from './firebase';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// תיקון 7: קומפוננטת שעון
function Clock() {
    const [time, setTime] = useState(new Date());
    useEffect(() => {
        const timerId = setInterval(() => setTime(new Date()), 1000);
        return () => clearInterval(timerId);
    }, []);
    return <div className="text-lg font-mono text-gray-400">{time.toLocaleTimeString('he-IL')}</div>;
}

const cacheRtl = createCache({ key: 'muirtl', stylisPlugins: [prefixer, rtlPlugin] });
const theme = createTheme({ direction: 'rtl' });

export default function DriverPage() {
    const [trips, setTrips] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const auth = getAuth();
    const user = auth.currentUser;

    useEffect(() => {
        if (!user) { setLoading(false); return; }
        const tripsRef = collection(db, 'users', user.uid, 'trips');
        const unsubscribe = onSnapshot(tripsRef, (snapshot) => {
            // תיקון 1: סינון נסיעות מבוטלות
            const tripsList = snapshot.docs
                .map(doc => ({ id: doc.id, ...doc.data() }))
                .filter(trip => trip.status !== 'cancelled');
            setTrips(tripsList);
            setLoading(false);
        }, (error) => { console.error("Error fetching trips: ", error); setLoading(false); });
        return () => unsubscribe();
    }, [user, navigate]);

    const approveTrip = async (tripId) => {
        if (!user) return;
        const tripRef = doc(db, 'users', user.uid, 'trips', tripId);
        try { await updateDoc(tripRef, { status: 'confirmed' }); }
        catch (error) { console.error("Error approving trip:", error); }
    };

const cancelTrip = async (tripId) => {
    if (!user) return;
    const tripRef = doc(db, 'users', user.uid, 'trips', tripId);
    
    // הוספנו אישור לפני המחיקה
    if (window.confirm("האם אתה בטוח שברצונך לבטל את הנסיעה?")) {
        try {
            // התיקון: במקום לעדכן סטטוס, מוחקים את המסמך
            await deleteDoc(tripRef);
        } catch (error) {
            console.error('Error canceling trip:', error);
        }
    }
};

    if (loading) return <div className="min-h-screen bg-gray-900 flex items-center justify-center text-white">טוען...</div>;
    if (!user) return <div className="min-h-screen bg-gray-900 flex items-center justify-center text-white">יש להתחבר כדי לראות את עמוד הנהג.</div>;

    return (
        <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div className="min-h-screen bg-gray-900 text-white p-4">
                        <div className="max-w-6xl mx-auto">
                            <div className="mb-6 text-center">
                                <h1 className="text-3xl font-bold text-amber-400">לוח הזמנות</h1>
                                <Clock />
                            </div>
                            <div className="bg-gray-800 rounded-lg p-6">
                                <Calendar trips={trips} onApproveTrip={approveTrip} onCancelTrip={cancelTrip} />
                            </div>
                        </div>
                    </div>
                </LocalizationProvider>
            </ThemeProvider>
        </CacheProvider>
    );
}